// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"47f13490","316":"16eeea19","670":"36bf91bf","859":"1a2b1df5","933":"0aa1e61f"}[chunkId] + ".chunk.js";
};